var _g, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_860",
    "data-name": "Group 860",
    transform: "translate(0 3.684)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2921",
    "data-name": "Path 2921",
    d: "M13.142,92.939a2.033,2.033,0,0,1-.79.488l-2.859.953a2.017,2.017,0,0,1-.639.1h0a2.022,2.022,0,0,1-1.918-2.661l.953-2.859a2.031,2.031,0,0,1,.488-.79L14.552,82H2.471A2.474,2.474,0,0,0,0,84.471V98.846a2.474,2.474,0,0,0,2.471,2.471H16.846a2.474,2.474,0,0,0,2.471-2.471V86.765Z",
    transform: "translate(0 -82)",
    fill: "#d6d6d6"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2922",
    "data-name": "Path 2922",
    d: "M183.236,61.7a.673.673,0,0,0-.163.263l-.953,2.859a.674.674,0,0,0,.852.852l2.859-.953a.673.673,0,0,0,.263-.163l8.418-8.418-2.859-2.859Z",
    transform: "translate(-173.906 -50.891)",
    fill: "#d6d6d6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2923",
    "data-name": "Path 2923",
    d: "M418.989.329a1.123,1.123,0,0,0-1.588,0L416.289,1.44,419.148,4.3l1.112-1.112a1.123,1.123,0,0,0,0-1.588Z",
    transform: "translate(-397.588 0)",
    fill: "#d6d6d6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditor);
export default __webpack_public_path__ + "static/media/editor.4f38b27008ccbe03b5ccf594dcc77b1e.svg";
export { ForwardRef as ReactComponent };